import { render, staticRenderFns } from "./menu5.vue?vue&type=template&id=57fe223e&scoped=true"
import script from "./menu5.vue?vue&type=script&lang=js"
export * from "./menu5.vue?vue&type=script&lang=js"
import style0 from "./menu5.vue?vue&type=style&index=0&id=57fe223e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57fe223e",
  null
  
)

export default component.exports